// extracted by mini-css-extract-plugin
export default {"list_menu":"index_list_menu_CGPUt","morehNew":"index_morehNew_6baYl","more":"index_more_VrWr4"};